import { createElement } from 'react';
import { AdvanceTableConfig } from './types';

import { TableLayoutTemplate } from '@aibees/shared/features/advance-table/components/table-layout-modifier-dialog';
import { cloneDeep } from 'lodash-es';
import * as Styled from './styles';

const ACTIONS_COL_ID = 'actions-column';

export function appendActionColumnToConfig(conf: AdvanceTableConfig) {
  const result = {
    ...conf,
    columns: [...(conf.columns || [])],
  };

  if (result.actions.length && result.columns.at(-1)?.id !== ACTIONS_COL_ID)
    result.columns.push({
      id: ACTIONS_COL_ID,
      label: '',
      ...conf.actionsConfig,
      render: (_, item, rowNumber) => (
        <Styled.ActionsWrapper
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            gap: 0.5,
            ...conf.actionsConfig?.sx,
          }}
        >
          {result.actions?.map((component) =>
            createElement(component, {
              key: (component as any).displayName,
              item,
              rowNumber,
              disabled: conf.actionsConfig?.disabled,
            })
          )}
        </Styled.ActionsWrapper>
      ),
    });
  return result;
}

export function addExtraFilter(
  config: AdvanceTableConfig,
  filters: AdvanceTableConfig['extraFilters']
) {
  if (!filters || Object.keys(filters).length === 0) {
    return config; // No extra filters, return original config
  }

  // Merge extraFilters immutably
  return {
    ...config,
    extraFilters: {
      ...config.extraFilters,
      ...filters,
    },
  };
}
export function applyTableColumnModifierPresetOnConfig(
  config: AdvanceTableConfig,
  template?: TableLayoutTemplate
) {
  const updatedConf = cloneDeep(config);
  const columnIds = updatedConf.columns.map((x) => x.key ?? x.id) as string[];
  const included = template?.included ?? [];
  const excluded = template?.excluded ?? [];

  updatedConf.columns
    ?.filter((x) => !x.disabledInColumnModifier)
    ?.map((col) => {
      col.order = excluded?.findIndex((x) => x === (col.key ?? col.id));
      col.hide =
        col.key || col.id
          ? excluded?.includes((col.key ?? col.id)?.toString() ?? '')
          : false;
      return col;
    });

  updatedConf.columns.sort((a, b) => {
    const aId = a.key ?? (a.id as string);
    const bId = b.key ?? (b.id as string);
    if (a.hide && !b.hide) return 1;
    if (a.hide && b.hide) {
      if (columnIds.indexOf(aId) > columnIds.indexOf(bId)) return 1;
      else return -1;
    }
    if (included?.indexOf(aId) > included?.indexOf(bId)) return 1;
    if (included?.indexOf(aId) < included?.indexOf(bId)) return -1;
    return 0;
  });

  return updatedConf;
}
